import { render, staticRenderFns } from "./detalhesClientes.vue?vue&type=template&id=4d306ab8&"
import script from "./detalhesClientes.vue?vue&type=script&lang=js&"
export * from "./detalhesClientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports